import { ORGANIZATION_DATA } from '../constants/seo';

type StructuredDataEntity = {
  '@type': string;
  [key: string]:
    | string
    | Record<string, string | number | undefined>
    | Record<string, string | number | undefined>[]
    | undefined
    | null;
};

export const getStructuredData = (...entities: StructuredDataEntity[]): string =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [ORGANIZATION_DATA, ...entities],
  });
